import React, { useState } from "react";
import {
    TextareaAutosize,
    Box,
    FormControl,
    FormHelperText,
    InputLabel,
} from "@material-ui/core";

export const JSONTextArea = ({
    id,
    value,
    onChange,
    placeholder,
    label,
    validate,
}) => {
    const [localValue, setLocalValue] = useState(value ?? "");
    const [error, setError] = useState("");

    const handleChange = (event) => {
        const value = event.target.value;
        setLocalValue(value);
        if (validate(value)) {
            setError("");
            if (onChange) {
                onChange(event);
            }
        } else {
            setError("Invalid JSON structure");
        }
    };

    return (
        <Box sx={{ minWidth: 120, maxWidth: 500 }}>
            <InputLabel>{label}</InputLabel>
            <FormControl fullWidth error={!!error}>
                <TextareaAutosize
                    id={id}
                    minRows={3}
                    value={localValue}
                    onChange={handleChange}
                    placeholder={placeholder || "Insert JSON here"}
                    style={{
                        width: "100%",
                        padding: "8px",
                        fontSize: "0.875rem",
                        marginTop: "8px",
                    }}
                />
                {error && <FormHelperText>{error}</FormHelperText>}
            </FormControl>
        </Box>
    );
};

export default JSONTextArea;
